import React, { Component } from "react";
import { Link } from "react-router-dom";

class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-dark bg-dark navbar-expand-lg mb-3">
        <Link to="/" className="navbar-brand">
          Exercise Tracker
        </Link> 
        <div className="collpase navbar-collpase">
          <div className="navbar-nav mr-auto">
            <div className="navbar-item">
              <Link to='/' className="nav-link">Exercises</Link>
            </div>
            <div className="navbar-item">
              <Link to='/create' className="nav-link">Create Exercise Log</Link>
            </div>
            <div className="navbar-item">
              <Link to="/user" className="nav-link">Create User</Link>
            </div>
            <div className="navbar-item">
               <a href='https://shakirjamil.com' className="nav-link btn btn-outline-info">Shakir Jamil</a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
